import createVueApp from '@phoenix/createVueApp';
import WishlistButton from '../components/wishlist/WishlistButton.vue';

Array.from(document.querySelectorAll('.phoenix-wishlist-button')).forEach((el) => {
  const app = createVueApp({}, true);
  app.component('WishlistButton', WishlistButton);
  app.mount(el);
});
